import {
  GET_BUDGET_MANAGEMENT_REPORT_FETCH,
  GET_BUDGET_MANAGEMENT_REPORT_SUCCESS,
  GET_BUDGET_MANAGEMENT_REPORT_REJECTED,
  GET_BUDGET_MANAGEMENT_REPORT_CLEAR,
} from "./../../Constants";

const initialState = {
  budgetManagement: { data: [], isLoading: false, isRejected: false },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_BUDGET_MANAGEMENT_REPORT_FETCH:
      return {
        ...state,
        budgetManagement: {
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_BUDGET_MANAGEMENT_REPORT_SUCCESS:
      return {
        ...state,
        budgetManagement: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_BUDGET_MANAGEMENT_REPORT_REJECTED:
      return {
        ...state,
        budgetManagement: {
          isLoading: false,
          isRejected: true,
        },
      };
    case GET_BUDGET_MANAGEMENT_REPORT_CLEAR:
      return {
        ...state,
        budgetManagement: {
          data: [],
          isLoading: false,
          isRejected: false,
        },
      };
    default:
      return state;
  }
};
